import { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Content from "./pages/content/Content.js";
import Login from "./pages/content/content-main/login/login.js";
import { auth, firebase } from "./configs/firebase.config.js";
import "./App.css";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const [splash, setSplash] = useState(true);
  const pathname = location.pathname;
  const navigate = useNavigate();
  const showFeeAccountLoads = process.env.REACT_APP_SHOW_FEE_ACCOUNT_LOADS==="true"
  const showTransactionsPage =
    process.env.REACT_APP_SHOW_TRANSACTIONS_PAGE === "true";
  const showWalletLoads = process.env.REACT_APP_SHOW_WALLET_LOADS === "true";
  const showStatements = process.env.REACT_APP_SHOW_STATEMENTS === "true";
  const showPayoutStatus = process.env.REACT_APP_SHOW_PAYOUT_STATUS === "true";
  const showCollectWithdraw =
    process.env.REACT_APP_SHOW_COLLECT_WITHDRAW === "true";
  const showPayoutLoads = process.env.REACT_APP_SHOW_PAYOUT_LOADS === "true";
  const showFundSubAccount =
    process.env.REACT_APP_SHOW_FUND_SUB_ACCOUNT === "true";
  const showCollectStatusWithCollectRef =
    process.env.REACT_APP_SHOW_COLLECT_STATUS_WITH_COLLECT_REF === "true";
  const showCollectStatusWithUTR =
    process.env.REACT_APP_SHOW_COLLECT_STATUS_WITH_UTR === "true";
  const showCollectStatusWithCRN =
    process.env.REACT_APP_SHOW_COLLECT_STATUS_WITH_CRN === "true";
  console.log("showTransactionsPage -> " + showTransactionsPage);
  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/otpverification":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    console.log(auth);

    auth.onAuthStateChanged(function (user) {
      if (user) {
        //do nothin
        setSplash(false);
      } else {
        navigate("/login");
        setSplash(false);
      }
    });
  }, [splash]);

  return (
    <div className="appresponsive">
      {splash && (
        <div className="SplashScreen">
          <img className="splash_img" alt="" src="/Splash-Screen.avif" />
        </div>
      )}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        {showTransactionsPage && (
          <Route path="/content/txn" element={<Content />} />
        )}
        {showFeeAccountLoads && (
           <Route path="/content/feeAccountLoads" element={<Content />} />
        )}
        {showWalletLoads && (
          <Route path="/content/walletloads" element={<Content />} />
        )}
        {/* <Route path="/content/load" element={<Content/>}/> */}
        {showStatements && (
          <Route path="/content/stmts" element={<Content />} />
        )}
        {showPayoutStatus && (
          <Route path="/content/payout" element={<Content />} />
        )}
        {showCollectStatusWithCollectRef && (
          <Route path="/content/collectstatus" element={<Content />} />
        )}
        {showCollectWithdraw && (
          <Route path="/content/withdraw" element={<Content />} />
        )}
        {showPayoutLoads && (
          <Route path="/content/load_payout_master" element={<Content />} />
        )}
        {showFundSubAccount && (
          <Route path="/content/fund_merchant_account" element={<Content />} />
        )}
        {showCollectStatusWithUTR && (
          <Route path="/content/check_status_with_utr" element={<Content />} />
        )}
        {showCollectStatusWithCRN && (
          <Route path="/content/check_status_with_crn" element={<Content />} />
        )}
        {<Route path="/content/admin" element={<Content />} />}
      </Routes>
    </div>
  );
}
export default App;
